export default [
    {
        path: '/emcadmin/plans/installments',
        name: 'emcsoft-plans-installments',
        component: () => import ('./views/InstallmentIndex'),
        meta: {
            title: 'Parcelamentos',
            icon: 'mdi-cash-register',
            breadcrumbs: [
                { text: 'Descrição da rota', disabled: true }
            ]
        }
    },
]
